<form [formGroup]="input.formGroup">
	<nz-card [nzTitle]="cardTitle"  [nzExtra]="sectionCardExtra" class="mt-3" [ngClass]="{'danger-card': !input.formGroup.valid}">
		<ng-template #cardTitle>
			<app-invalid-form-indicator [form]="input.formGroup" class="me-3"></app-invalid-form-indicator>
			Step: {{input._label}}
		</ng-template>
		<ng-template #sectionCardExtra>
			<button nz-button nzType="dashed" (click)="doEdit()" class="me-3">
				<app-invalid-form-indicator [form]="input.formGroup" [fields]="['label','description','stepOrder','slaDurationWarning','slaDurationBreach','slaDurationEscalation']" class="me-3"></app-invalid-form-indicator>
				Edit
			</button>
			<button nz-button nzType="primary" (click)="doRemove()" nzDanger><fa-icon [icon]="faTrash"></fa-icon></button>
		</ng-template>

		<div class="row">
			<div class="col">
				<nz-card nzTitle="Display Fields">
					<div class="row">
						<div class="col offset-1">
							<div *ngFor="let group of input.readOnlyFields;let i=index">
								<h5 [ngClass]="{'mt-4':i>0}">
									{{group.group}}
									<button (click)="selectAll(group)" nz-button nzSize="small" nzType="link">all</button>|<button (click)="selectNone(group)" nz-button nzSize="small" nzType="link">none</button>
								</h5>
								<div class="row">
									<div class="col-3" *ngFor="let field of group.fields">
										<nz-form-control>
											<label nz-checkbox [formControl]="field.formControl">{{ field._name }}</label>
										</nz-form-control>
									</div>
								</div>
							</div>
						</div>
					</div>
				</nz-card>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<nz-card nzTitle="Report Status Alias">
					<div class="row">
						<div class="col offset-1">
							<nz-form-item *ngFor="let status of input.statuses">
								<ng-container [formGroup]="status.formGroup">
									<nz-form-label [nzSpan]="10" nzRequired>
										<app-invalid-form-indicator [form]="status.formGroup" field="reportAlias" class="me-3"></app-invalid-form-indicator>
										{{status._label}}
									</nz-form-label>
									<nz-form-control [nzSpan]="14">
										<input nz-input formControlName="reportAlias" [placeholder]="status._label"/>
									</nz-form-control>
								</ng-container>
							</nz-form-item>
						</div>
					</div>
				</nz-card>
			</div>
		</div>

		<div class="row" *ngFor="let section of input.sections">
			<div class="col">
				<app-workflow-form-section [input]="section"></app-workflow-form-section>
			</div>
		</div>
		<button nz-button nzType="dashed" class="mt-1 me-1" (click)="addSection()">+ Add Section</button>







		<h4 class="mt-3">Buttons</h4>

		<nz-table nzSize="small" [nzData]="input.buttons" [nzFrontPagination]="false" class="table-secondary-zorro">
			<thead>
				<tr>
					<th class="col-state">State</th>
					<th class="col-buttons">Buttons</th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let state of input.statuses">
					<tr>
						<td>
							<app-invalid-form-indicator [form]="state.formGroup" class="me-3"></app-invalid-form-indicator>
							{{state._label}}
						</td>
						<td>
							<ng-container *ngFor="let button of input.buttons">
								<ng-container *ngIf="button.payload.statusId == state.payload.id">
									<button *ngIf="button._buttonStyle == 'Danger'"
										nz-button
										nzDanger
										nzSize="small"
										[nzType]="button._buttonType"
										class="me-1" (click)="viewButton(button)">
										<app-invalid-form-indicator [form]="button.formGroup" class="me-3"></app-invalid-form-indicator>
										{{button._label}}
									</button>
									<button *ngIf="button._buttonStyle == 'Ghost'"
										nz-button
										nzGhost
										nzSize="small"
										[nzType]="button._buttonType"
										class="me-1" (click)="viewButton(button)">
										<app-invalid-form-indicator [form]="button.formGroup" class="me-3"></app-invalid-form-indicator>
										{{button._label}}
									</button>
									<button *ngIf="button._buttonStyle == 'Default'"
										nz-button
										nzSize="small"
										[nzType]="button._buttonType"
										class="me-1" (click)="viewButton(button)">
										<app-invalid-form-indicator [form]="button.formGroup" class="me-3"></app-invalid-form-indicator>
										{{button._label}}
									</button>
								</ng-container>
							</ng-container>
							<button nz-button nzSize="small" nzType="dashed" nzS class="me-1 float-end" (click)="addButton(state)">+ Add Button</button>
						</td>
					</tr>
				</ng-container>
			</tbody>
		</nz-table>
	</nz-card>

	<ng-template #editPopup>
		<nz-form-item>
			<nz-form-label [nzSpan]="10" nzRequired>
				<app-invalid-form-indicator [form]="input.formGroup" field="label" class="me-3"></app-invalid-form-indicator>
				Label
			</nz-form-label>
			<nz-form-control [nzSpan]="14" nzErrorTip="Label is required">
				<input nz-input formControlName="label" />
			</nz-form-control>
		</nz-form-item>

		<nz-form-item>
			<nz-form-label [nzSpan]="10" nzRequired>
				<app-invalid-form-indicator [form]="input.formGroup" field="description" class="me-3"></app-invalid-form-indicator>
				Description
			</nz-form-label>
			<nz-form-control [nzSpan]="14" nzErrorTip="Description is required">
				<textarea nz-input formControlName="description" rows="3"></textarea>
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-label [nzSpan]="10" nzRequired>
				<app-invalid-form-indicator [form]="input.formGroup" field="stepOrder" class="me-3"></app-invalid-form-indicator>
				Order
			</nz-form-label>
			<nz-form-control [nzSpan]="14" nzErrorTip="Order">
				<input nz-input formControlName="stepOrder" rows="3" />
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-label [nzSpan]="10" [nzTooltipTitle]="durationHelp" nzRequired>
				<app-invalid-form-indicator [form]="input.formGroup" field="slaDurationWarning" class="me-3"></app-invalid-form-indicator>
				SLA Duration Warning
			</nz-form-label>
			<nz-form-control [nzSpan]="14" nzErrorTip="Please enter a valid duration (e.g. 48h 30m)">
				<input nz-input formControlName="slaDurationWarning" />
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-label [nzSpan]="10" [nzTooltipTitle]="durationHelp" nzRequired>
				<app-invalid-form-indicator [form]="input.formGroup" field="slaDurationBreach" class="me-3"></app-invalid-form-indicator>
				SLA Duration Breach
			</nz-form-label>
			<nz-form-control [nzSpan]="14" nzErrorTip="Please enter a valid duration (e.g. 48h 30m)">
				<input nz-input formControlName="slaDurationBreach" />
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-label [nzSpan]="10" [nzTooltipTitle]="durationHelp" nzRequired>
				<app-invalid-form-indicator [form]="input.formGroup" field="slaDurationEscalation" class="me-3"></app-invalid-form-indicator>
				SLA Duration Escalation
			</nz-form-label>
			<nz-form-control [nzSpan]="14" nzErrorTip="Please enter a valid duration (e.g. 48h 30m)">
				<input nz-input formControlName="slaDurationEscalation" />
			</nz-form-control>
		</nz-form-item>

		<ng-template #durationHelp>
			To specify a duration, you will provide a number followed by it's corresponding unit.
			<ul>
				<li>Year: <code>#</code> [y; year; years]</li>
				<li>Month: <code>#</code> [M; month; months]</li>
				<li>Day: <code>#</code> [d; day; days]</li>
				<li>Week: <code>#</code> [w; week; weeks]</li>
				<li>Hour: <code>#</code> [h; hour; hours]</li>
				<li>Minute: <code>#</code> [m; minute; minutes]</li>
				<li>Second: <code>#</code> [s; second; seconds]</li>
				<li>Work Week: <code>#</code> [ww; work week; work weeks]</li>
				<li>Work Day: <code>#</code> [wd; work day; work days]</li>
				<li>Work Hour: <code>#</code> [wh; work hour; work hours]</li>
			</ul>
			Eg:  1ww 3wd equates to 1 work week and 3 working days or 8 working days
		</ng-template>

		<nz-form-item>
			<nz-form-label [nzSpan]="10" [nzRequired]="true">Status List</nz-form-label>
			<nz-form-control [nzSpan]="14">
				<div *ngFor="let status of input.statuses; let i = index" [formGroup]="status.formGroup">
					<div class="row g-1 mb-1">
						<div class="col">
							<input nz-input placeholder="Label" formControlName="label" />
						</div>
						<div class="col">
							<button nz-button nzType="default" nzDanger (click)="removeStatus(i)">X</button>
						</div>
					</div>
				</div>
				<button nz-button nzType="dashed" (click)="addStatus()">+ Add Status</button>
			</nz-form-control>
		</nz-form-item>
	</ng-template>
</form>
